import { Component, inject, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AppModule } from '../../../app-module';


@Component({
  selector: 'oaj-modal-iframe-itx',
  templateUrl: './modal-iframe.component.html',
  styleUrls: ['./modal-iframe.component.css'],
  imports: [AppModule]
})
export class ModalIframeComponent {

  @Input()
  titulo!: string;
  @Input()
  url!: string;
  @Input()
  btnText!: string;

  private activeModal : NgbActiveModal = inject(NgbActiveModal);

  public close() {
    this.activeModal.close(true);
  }
}
